export default {
    errorMessages: {
        defaultIBRMessage: 'Sorry, it looks like you don\'t qualify for Income-Based Repayment based on the debt and income information you provided.',
        standardMessage: 'Please enter a higher monthly payment value',
    },
    tableHeading: {
        standard: 'STANDARD',
        ibr: 'IBR',
        icr: 'ICR',
        paye: 'PAYE',
        repaye: 'REPAYE',
    },
    radix: {
        binary: 2,
        octal: 8,
        decimal: 10,
        hexadecimal: 16,
    },
    marriedIncome: [
        11382,
        17959,
        21402,
        27979,
        34661,
        43536,
        54601,
        65671,
        82275,
        109938,
        148672,
        207925,
        339766,
    ],
    marriedPercentages: [
        50.52,
        56.68,
        59.56,
        67.79,
        75.22,
        87.61,
        100.00,
        100.00,
        109.40,
        125.00,
        140.60,
        150.00,
        200.00,
    ],
    unMarriedIncome: [
        11382,
        15662,
        20152,
        24745,
        29131,
        34661,
        43536,
        54602,
        65671,
        78929,
        101065,
        143142,
        164125,
        292335,
    ],
    unMarriedPercentages: [
        55,
        57.79,
        60.57,
        66.23,
        71.89,
        80.33,
        88.77,
        100,
        100,
        111.8,
        123.5,
        141.20,
        150,
        200,
    ],
};
